import React from 'react';
import { useState, useRef, useEffect } from 'react';
import './reservationTriplePicker.css';


import Datepicker from '../common/Datepicker/Datepicker.jsx';

function ReservationTriplePicker({

}) {
    if (typeof reservationData == 'undefined' || reservationData.products == undefined || reservationData.schedules == undefined) {
        return null;
    }

    if (reservationData.schedules.length == 0 || reservationData.products.length == 0) { 
        let btn =  document.getElementById('buynow-button');
        if (btn) {
            btn.querySelector('.title').innerHTML = reservationData.strings.soldOut;
        }
        return null; 
    }

    let ini_selectedProductId = reservationData.products[0]['productId'];

    let ini_selectedDate = (reservationData.schedules[ini_selectedProductId] && reservationData.schedules[ini_selectedProductId]['dates'] && reservationData.schedules[ini_selectedProductId]['dates'].length > 0) ? reservationData.schedules[ini_selectedProductId]['dates'][0]['value'] : null;

    const [showDatepicker, setShowDatepicker]   = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(ini_selectedProductId);
    const [selectedDate, setSelectedDate] = useState(ini_selectedDate);
    const [selectedTime, setSelectedTime] = useState('');

    const productSelectRef = useRef(null);
    const dateSelectRef = useRef(null);
    const calendarBtnRef = useRef(null);
    const prevShowDatepickerRef = useRef(false);

    // When the datepicker transitions from open to closed, return focus to the
    // calendar trigger button so keyboard users can Tab to the next control
    // sequentially (works for ESC, X button, and overlay-click close paths).
    // Gated on the WCAG-accessibility feature flag (mirrored to the
    // <html class="WCAG-accessibility"> by GF::documentClass()).
    useEffect(() => {
        if (typeof document === 'undefined' ||
            !document.documentElement ||
            !document.documentElement.classList ||
            !document.documentElement.classList.contains('WCAG-accessibility')) {
            return;
        }
        if (prevShowDatepickerRef.current && !showDatepicker && calendarBtnRef.current) {
            calendarBtnRef.current.focus();
        }
        prevShowDatepickerRef.current = showDatepicker;
    }, [showDatepicker]);

    function _selectedTimeChangedUIUpdate(t) {
        let btn =  document.getElementById('buynow-button');
        if (btn) {
            if (t) {
                btn.classList.remove('disabled')
                console.log('enabled')
            } else {
                btn.classList.add('disabled')
                console.log('disabed')
            }
        }
    }

    function onDatePicked(date) {
        if (! reservationData.isAjax) {
            return;
        }

        console.log('date picked1: ' + date);
        setSelectedDate(date);
        setSelectedTime('');
        setShowDatepicker(false);
    }

    function onOverlayPicked(e) {
        if (e.target.classList.contains('datepicker_ra_overlay')) {
            setShowDatepicker(false);
        }
    }

    function productChanged(e) {
        if (! reservationData.isAjax) {
            return;
        }

        let productId = e.target.value
        setSelectedProductId(productId);
        let date = reservationData.schedules[productId]['dates'].length > 0 ? reservationData.schedules[productId]['dates'][0]['value'] : null;
        setSelectedDate(date);
        setSelectedTime('');
    }

    /*
    function dateChanged(e) {
        //console.log('date selected1: ' + e.target.value);
        setSelectedDate(e.target.value);
    }
    */

    function clandarBtnClicked(e) {
        //document.getElementById('rtp_hint_text_box').focus();
        if (document.documentElement && document.documentElement.classList &&
            document.documentElement.classList.contains('WCAG-accessibility')) {
            calendarBtnRef.current = e.currentTarget;
        }
        setShowDatepicker(true);
        setTimeout(function(){
            let datecell = document.querySelector('.rtp_date_cell.active');
            if (datecell) {
                datecell.focus();
            }
        }, 0);
    }

    function timeClicked(e) {
        if (! reservationData.isAjax) {
            return;
        }
        let t = e.target.dataset.timeslot
        setSelectedTime(t);
    }

    function _getTimeSlotCss(slot, selectedTime){
        let selected =  slot.value==selectedTime;
        let css = {};
        if (selected) {
            css.background = reservationData.siteColors.primary
            css.color = reservationData.siteColors.white;
        }
        return css;
    }

    _selectedTimeChangedUIUpdate(selectedTime);

    let dateOptions = (reservationData.schedules[selectedProductId] && Array.isArray(reservationData.schedules[selectedProductId]['dates'])) ? reservationData.schedules[selectedProductId]['dates'] : [];
    //console.log('d1', selectedProductId,  reservationData.schedules[selectedProductId], dateOptions);

    let activeDates = {};
    for (let d of dateOptions) {
        activeDates[d.value] = 1;
    }

    let timeslots = (reservationData.schedules[selectedProductId] && typeof(reservationData.schedules[selectedProductId]['timeslots']) == 'object') ? reservationData.schedules[selectedProductId]['timeslots'] : {};
    let date_timeslots = Array.isArray(timeslots[selectedDate]) ? timeslots[selectedDate] : [];
    let rd = reservationData;
    let container_border_css = [SG.BD_2, SG.NO_BD_LEFT, SG.NO_BD_RIGHT, SG.NO_BD_TOP, SG.F_BODY].join(" ");

    return (
        <>
            <div className={'rtp_container ' + container_border_css} >
                {typeof(localStorage) != 'undefined' && localStorage.rtp_debug == '1' && reservationData.errors.length > 0 &&
                    <div className="rtp_error" style={{display: (reservationData.isLiveServer == 1) ? 'none' : 'block'}}>
                        {reservationData.errors.map(
                            (error, index) => {
                                return (
                                    <div key={index}>{error}</div>
                                )
                            }
                        )}
                    </div>
                }

                <div className='rtp_pd_row'>
                    <div className="product_select_div">
                        <label htmlFor="rtp_product_select" >{rd.strings.productSelectLable}</label>
                        <select
                            id="rtp_product_select"
                            className={"product_select " + SG.BD_PRIMARY + ' ' + SG.RC_BD_RADIUS} 
                            ref={productSelectRef} 
                            value={selectedProductId}
                            onChange={productChanged} 
                            style={{borderColor:rd.siteColors.primary}}
                            
                        >
                            {reservationData.products.map( 
                                (product, index) => { 
                                    return (
                                        <option key={'product_' + product.productId} value={product.productId}   > 
                                            {product.shortName}
                                        </option>
                                    ) 
                                } 
                            )}
                        </select>

                        <svg className='select_icon' width="20" height="20" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M83.3909 183.725L106.609 160.275L246.363 298.646L382.755 160.411L406.245 183.589L246.636 345.354L83.3909 183.725Z" fill={rd.siteColors.primary}/>
                        </svg>

                    </div>

                    {
                        /*
                        false && selectedDate && <select className="date_select" ref={dateSelectRef} value={selectedDate} onChange={dateChanged} >
                        {
                            dateOptions.map( 
                                (d, index) => { 
                                    return (
                                        <option key={'product_' + d.value} value={d.value}   > 
                                            {d.display}
                                        </option>
                                    ) 
                                } 
                            )
                        }
                        </select>
                        */
                    }

                    <div  className="calendar_btn_div">
                        <label htmlFor="rpt_calendar_btn" >{rd.strings.dateSelectLabel}</label>
                        <button type="button" id="rpt_calendar_btn" className="calendar_btn clean_button" onClick={clandarBtnClicked}
                            ref={calendarBtnRef}
                            style={{borderColor:rd.siteColors.primary}}
                        >
                            <span className={SG.F_BODY}>
                            {
                                dateOptions.map( 
                                    (d, index) => { 
                                        return d.value == selectedDate ? d.display : '';
                                    } 
                                )
                            }
                            </span>

                            <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.38525 4.27552C9.38525 2.99109 8.28798 1.9109 6.88525 1.9109V0.910904C8.79624 0.910904 10.3853 2.39579 10.3853 4.27552C10.3853 5.28069 9.92671 6.1785 9.20985 6.79103L8.56023 6.03077C9.07111 5.59424 9.38525 4.96736 9.38525 4.27552ZM1.88525 5.9109C1.88525 5.08248 2.55683 4.4109 3.38525 4.4109H7.88525V3.4109H3.38525C2.00454 3.4109 0.885254 4.53019 0.885254 5.9109V21.9109C0.885254 23.2916 2.00454 24.4109 3.38525 24.4109H20.3853C21.766 24.4109 22.8853 23.2916 22.8853 21.9109V5.9109C22.8853 4.53019 21.766 3.4109 20.3853 3.4109H19.4686V4.4109H20.3853C21.2137 4.4109 21.8853 5.08248 21.8853 5.9109V21.9109C21.8853 22.7393 21.2137 23.4109 20.3853 23.4109H3.38525C2.55683 23.4109 1.88525 22.7393 1.88525 21.9109V5.9109ZM11.4186 4.4109H16.0853V3.4109H11.4186V4.4109ZM3.88525 9.4109H19.8853V8.4109H3.88525V9.4109ZM14.8853 1.9109C16.288 1.9109 17.3853 2.99109 17.3853 4.27552C17.3853 4.96736 17.0711 5.59424 16.5602 6.03077L17.2098 6.79103C17.9267 6.1785 18.3853 5.28069 18.3853 4.27552C18.3853 2.39579 16.7962 0.910904 14.8853 0.910904V1.9109ZM4.88525 12.4109V14.4109H6.88525V12.4109H4.88525ZM4.38525 11.4109C4.10911 11.4109 3.88525 11.6348 3.88525 11.9109V14.9109C3.88525 15.187 4.10911 15.4109 4.38525 15.4109H7.38525C7.6614 15.4109 7.88525 15.187 7.88525 14.9109V11.9109C7.88525 11.6348 7.6614 11.4109 7.38525 11.4109H4.38525ZM4.88525 20.4109V18.4109H6.88525V20.4109H4.88525ZM3.88525 17.9109C3.88525 17.6348 4.10911 17.4109 4.38525 17.4109H7.38525C7.6614 17.4109 7.88525 17.6348 7.88525 17.9109V20.9109C7.88525 21.187 7.6614 21.4109 7.38525 21.4109H4.38525C4.10911 21.4109 3.88525 21.187 3.88525 20.9109V17.9109ZM10.8853 12.4109V14.4109H12.8853V12.4109H10.8853ZM10.3853 11.4109C10.1091 11.4109 9.88525 11.6348 9.88525 11.9109V14.9109C9.88525 15.187 10.1091 15.4109 10.3853 15.4109H13.3853C13.6614 15.4109 13.8853 15.187 13.8853 14.9109V11.9109C13.8853 11.6348 13.6614 11.4109 13.3853 11.4109H10.3853ZM10.8853 20.4109V18.4109H12.8853V20.4109H10.8853ZM9.88525 17.9109C9.88525 17.6348 10.1091 17.4109 10.3853 17.4109H13.3853C13.6614 17.4109 13.8853 17.6348 13.8853 17.9109V20.9109C13.8853 21.187 13.6614 21.4109 13.3853 21.4109H10.3853C10.1091 21.4109 9.88525 21.187 9.88525 20.9109V17.9109ZM16.8853 12.4109V14.4109H18.8853V12.4109H16.8853ZM16.3853 11.4109C16.1091 11.4109 15.8853 11.6348 15.8853 11.9109V14.9109C15.8853 15.187 16.1091 15.4109 16.3853 15.4109H19.3853C19.6614 15.4109 19.8853 15.187 19.8853 14.9109V11.9109C19.8853 11.6348 19.6614 11.4109 19.3853 11.4109H16.3853ZM16.8853 20.4109V18.4109H18.8853V20.4109H16.8853ZM15.8853 17.9109C15.8853 17.6348 16.1091 17.4109 16.3853 17.4109H19.3853C19.6614 17.4109 19.8853 17.6348 19.8853 17.9109V20.9109C19.8853 21.187 19.6614 21.4109 19.3853 21.4109H16.3853C16.1091 21.4109 15.8853 21.187 15.8853 20.9109V17.9109Z" fill={rd.siteColors.primary}/>
                            </svg>

                        </button> 
                    </div>

                </div>

                <div className="rtp_title_row" >
                    {reservationData.strings.timeListLabel}
                </div>

                <div className="rtp_timeslots_div">
                    {
                        date_timeslots.map(
                            (slot, index) => {
                                return(
                                    <button type="button" className={'timeslot_btn clean_button ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 

                                        key={slot.value} data-timeslot={slot.value} data-productid={selectedProductId}
                                        onClick={timeClicked} style={_getTimeSlotCss(slot, selectedTime)} 
                                    >
                                        {slot.display}
                                    </button>
                                )
                            }
                        )
                    }
                </div>

                {
                    (reservationData.hintTextBoxRequired == '1') &&
                    <>
                        <div className="rtp_title_row" >
                            {reservationData.strings.hintText}
                        </div>
                        <textarea id="rtp_hint_text_box" name="CartItemSocialInfo[info]" className={'rtp_hint_text_box ' + SG.BD_PRIMARY + '  ' + SG.RC_BD_RADIUS + ' ' + SG.F_BODY} 
                            rows="3"
                        >
                        </textarea>
                    </>
                
                }

                <input type="hidden" name="subproducts[version]" value={selectedProductId} />
                <input type="hidden" name="Schedule[date][0]" value={selectedTime} />

                {typeof(localStorage) != 'undefined' && localStorage.rtp_debug == '1' &&
                    <div style={{padding: '10px 0'}}>
                        selected productId: {selectedProductId}<br />
                        selected date: {selectedDate}<br />
                        selected time: {selectedTime}
                    </div>
                }
            </div>

            <Datepicker 
                startDate = {reservationData.startDate}
                monthTexts = {reservationData.monthTexts}
                weekDayTexts = {reservationData.weekDayTexts}
                activeDates = {activeDates}
                dateLegnedAvailable = {reservationData.strings.dateLegnedAvailable}
                dateLegnedUnavailable = {reservationData.strings.dateLegnedUnavailable}
                show = {showDatepicker} 
                onClose = {setShowDatepicker}
                onDatePicked = {onDatePicked}
                onOverlayPicked = {onOverlayPicked}
                selectedDate = {selectedDate}
                selectedDateBackgroundColor = {reservationData.siteColors.primary}
                selectedDateColor = {reservationData.siteColors.white}
            />
        </>
    )
}

export default ReservationTriplePicker;